<template>
  <div :id="themeName" class="remoteClient">
    <Header :theme="theme" />
    <router-view :theme="theme"></router-view>
    <Status />
  </div>
</template>

<script>
const user = JSON.parse(localStorage.state).usuario;
const theme = user.white_label;
import themes from "@/conf/themes.js";
if (theme === "vero") {
  require("../../../../public/theme/vero/style-vero.scss");
} else {
  require("../../../../public/theme/ns/style-ns.scss");
}
import translate from "@/conf/translate";

// FAVICON
const changeFavicon = (link) => {
  let $favicon = document.querySelector('link[rel="icon"]');
  // If a <link rel="icon"> element already exists,
  // change its href to the given link.
  if ($favicon !== null) {
    $favicon.href = link;
    // Otherwise, create a new element and append it to <head>.
  } else {
    $favicon = document.createElement("link");
    $favicon.rel = "icon";
    $favicon.href = link;
    document.head.appendChild($favicon);
  }
};

if (theme !== "ns" && themes[theme].favicon) {
  changeFavicon(themes[theme].favicon);
}

// CARREGAR CHATBOT

setTimeout(function () {
  if (location.pathname == "/atendimento") {
    (function (d, m) {
      const apiKey = "SrPoYRF3AcQKtz3dg619xONycRVgkpjw";

      /*---------------- Kommunicate settings start ----------------*/
      var kommunicateSettings = {
        appId: user.km_app_id,
        automaticChatOpenOnNavigation: true,
        popupWidget: true,
        userName: user.nome,
        email: user.email,
        userId: user.email,
        ...translate,
        onInit: function () {
          /* ESCOLHENDO O BOT CERTO */
          var defaultSettings = {
            defaultBotIds: [user.id_bot_km], // Replace <BOT_ID> with your bot ID which you can find in bot section of dashboard
            defaultAssignee: user.id_bot_km, // Replace <BOT_ID> with your bot ID which you can find in bot section of dashboard
            skipRouting: true,
          };

          // eslint-disable-next-line no-undef
          Kommunicate.updateSettings(defaultSettings);

          /*   DEFINIR CSS */
          fetch(themes[theme].chat)
            .then((response) => response.text())
            .then((css) => {
              // eslint-disable-next-line no-undef
              Kommunicate.customizeWidgetCss(css);
            });

          var chatContext = {
            id_usuario: user.id,
            nome: user.nome,
            email: user.email,
          };
          // eslint-disable-next-line no-undef
          Kommunicate.updateChatContext(chatContext);

          let url = "https://services.kommunicate.io/rest/ws/user/update";
          let headers = {
            "Api-Key": apiKey,
            "Of-User-Id": window.kommunicate._globals.userId,
            "Content-Type": "application/json",
          };
          let data = {
            displayName: user.nome,
            email: user.email,
            metadata: {
              id: user.id,
              nome: user.nome,
              email: user.email,
              cliente: user.cliente,
            },
          };
          let ob = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data),
          };
          fetch(url, ob);
          var events = {
            onMessageReceived: function (resp) {
              if (resp.message.metadata && resp.message.metadata.carrega_chat)
                // eslint-disable-next-line no-undef
                Kommunicate.openConversation(
                  resp.message.metadata.carrega_chat
                );
            },
            /* onMessageSent: function (resp) {
              console.log(resp);
              //called when the message is sent
            }, */
          };
          // eslint-disable-next-line no-undef
          Kommunicate.subscribeToEvents(events);
        },
      };

      /*----------------- Kommunicate settings end ------------------*/

      var s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://widget.kommunicate.io/v2/kommunicate.app";
      var h = document.getElementsByTagName("head")[0];
      h.appendChild(s);
      window.kommunicate = m;
      m._globals = kommunicateSettings;
    })(document, window.kommunicate || {});
  }
}, 700);

import Header from "@/components/HeaderClientRemote.vue";
import Status from "@/components/Status.vue";

export default {
  name: "RemoteClient",
  components: {
    Header,
    Status,
  },
  data() {
    return {
      themeName: theme,
      theme: themes[theme],
    };
  },
};
</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;500;600&display=swap");
body {
  background: #fff;
}
</style>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.remoteClient {
  font-family: Work Sans;
  background: #fff;
}
</style>
